import React from "react";
import ReactECharts from "echarts-for-react";
import { ALEA_INFO } from "../../constants.js";

export default function PertesChart({ data, risque }) {
  const { total, repartition } = data;
  const totalSorted = [...total].sort((a, b) => a.YearGroup - b.YearGroup);
  const years = totalSorted.map((d) => d.YearGroup);

  const aleaCodes = Object.keys(ALEA_INFO);

  const lineOption = {
    tooltip: { trigger: "axis" },
    grid: { left: 60, right: 20, top: 20, bottom: 40, containLabel: true },
    xAxis: { type: "category", data: years, boundaryGap: false, axisLabel: { fontSize: 14 } },
    yAxis: { type: "value", name: `Perte ${risque} (%)`, nameLocation: "middle", nameGap: 45 },
    series: [
      {
        name: "Total",
        type: "line",
        symbol: "circle",
        symbolSize: 10,
        lineStyle: { width: 2.5, color: "#c9a227" },
        itemStyle: { color: "#c9a227" },
        data: totalSorted.map((d) => d.val),
      },
    ],
  };

  const pieSeries = years.map((year, i) => {
    const centerX = years.length === 1 ? "50%" : `${16 + i * (68 / (years.length - 1))}%`;
    const rows = repartition.filter((r) => r.YearGroup === year);
    return {
      name: String(year),
      type: "pie",
      radius: "60%",
      center: [centerX, "45%"],
      label: { show: false },
      labelLine: { show: false },
      data: aleaCodes.map((code) => ({
        name: ALEA_INFO[code].label,
        value: rows.find((r) => r.alea === code)?.val ?? 0,
        itemStyle: { color: ALEA_INFO[code].color },
      })),
    };
  });

  const pieOption = {
    tooltip: { trigger: "item" },
    legend: { bottom: 0, data: aleaCodes.map((c) => ALEA_INFO[c].label) },
    // étiquette d'année sous chaque camembert
    graphic: years.map((year, i) => ({
      type: "text",
      left: years.length === 1 ? "50%" : `${16 + i * (68 / (years.length - 1))}%`,
      top: "82%",
      style: { text: String(year), fontSize: 14, fontWeight: "bold", fill: "#333" },
    })),
    series: pieSeries,
  };

  return (
    <div style={{ display: "flex", gap: 16, alignItems: "flex-start" }}>
      <div style={{ flex: "1 1 0" }}>
        <ReactECharts option={lineOption} style={{ height: 480 }} notMerge lazyUpdate />
      </div>
      <div style={{ flex: "1.4 1 0" }}>
        <ReactECharts option={pieOption} style={{ height: 480 }} notMerge lazyUpdate />
      </div>
    </div>
  );
}